<template>
  <div class="moblie_menu">
    <!-- 我的金主 -->
    <div v-if="showOwner" id="owner_menu" class="moblie_box">
      <div v-for="(item, index) in mobile_owner_menu_list" :key="index">
        <div
          :class="isSelect == index ? 'select_menu_item ' : 'mobile_menu_item'"
          @click="handleMenuItem(index, item)"
          key="index"
        >
          <div class="line_item "></div>
          <i :class="item.iconUrl"></i>
          <div class="moblie_link">
            {{ item.pathName }}
          </div>
        </div>
      </div>
    </div>
    <!-- 我的数据 -->
    <div id="ownerData_menu" v-if="showOwnerData" class="moblie_box">
      <div v-for="(item, index) in mobile_ownerData_menu_list" :key="index">
        <div
          :class="isSelect == index ? 'select_menu_item ' : 'mobile_menu_item'"
          @click="handleMenuItem(index, item)"
          key="index"
        >
          <div class="line_item "></div>
          <i :class="item.iconUrl"></i>
          <div class="moblie_link">
            {{ item.pathName }}
          </div>
        </div>
      </div>
    </div>
    <!-- 当前菜单 -->
    <div id="current_menu" class="current_menu" v-show="showCurrentMenu">
      <div class="current_menu_item">
        <div class="line_item "></div>
        <i :class="currentMenuIcon"></i>
        {{ currentMenuName }}
      </div>
      <div class="more_menu" @click="handleMore">
        <i class="el-icon-arrow-down"></i>更多
      </div>
    </div>
    <!-- 底部菜单按钮 -->
    <div id="foot_menu" class="foot_list_box">
      <div
        class="foot_item"
        :class="isActive == 0 ? 'foot_item_active' : 'foot_item'"
        @click="handleOwner(0)"
      >
        金主
      </div>
      <div
        class="foot_item"
        :class="isActive == 1 ? 'foot_item_active' : 'foot_item'"
        @click="handleOwner(1)"
      >
        我的数据
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mobile_owner_menu_list: [
        {
          iconUrl: "iconfont icon-kehu",
          pathUrl: "/MyOwner",
          pathName: "我的金主"
        },
        {
          iconUrl: "iconfont icon-wp-sj",
          pathUrl: "/TaskCenter",
          pathName: "任务中心"
        },
        {
          iconUrl: "iconfont icon-wp-sj",
          pathUrl: "/OwnerBookInfo",
          pathName: "金主书籍信息"
        },
        {
          iconUrl: "iconfont icon-gonghaiguanli",
          pathUrl: "/OwnerHighSeas",
          pathName: "金主公海信息"
        },
        {
          iconUrl: "iconfont icon-jilu",
          pathUrl: "/DownloadFileRecord",
          pathName: "文件下载记录"
        },
        {
          iconUrl: "iconfont icon-zongcejieguochakan",
          pathUrl: "/ownerCheaterPool",
          pathName: "骗子库"
        },
        {
          iconUrl: "iconfont icon-chuyuanjiesuan",
          pathUrl: "/ownerFeeExpenditure",
          pathName: "其余费用支出"
        },
        {
          iconUrl: "iconfont icon-chuyuanjiesuan",
          pathUrl: "/ownerFeeIncome",
          pathName: "其余费用收入"
        },
        {
          iconUrl: "iconfont icon-xiazai",
          pathUrl: "/DownLoadManuscript",
          pathName: "下载周稿"
        }
      ],
      mobile_ownerData_menu_list: [
        {
          iconUrl: "iconfont icon-kaohe",
          pathUrl: "/OwnerExamine",
          pathName: "我的考核"
        },
        {
          iconUrl: "iconfont icon-data1",
          pathUrl: "/OwnerData",
          pathName: "我的数据"
        },
        {
          iconUrl: "iconfont icon-register",
          pathUrl: "/OwnerDayRecordMobile",
          pathName: "金主日结登记"
        },
        {
          iconUrl: "iconfont  icon-shuji",
          pathUrl: "/OwnerDaySheet",
          pathName: "金主日结表"
        },
        {
          iconUrl: "iconfont icon-register",
          pathUrl: "/OwnerWeekRecordMobile",
          pathName: "金主周结登记"
        },
        {
          iconUrl: "iconfont  icon-shuji",
          pathUrl: "/OwnerWeekSheet",
          pathName: "金主周结表"
        }
      ],
      currentMenuName: "", //当前菜单名称
      currentMenuIcon: "", //当前菜单图标
      showCurrentMenu: false, //展示当前菜单
      showOwner: false, //金主、写手菜单
      showOwnerData: false, //数据中心
      outsideShow: false, //区域外部
      isSelect: 0, //是否选择菜单项 0 ：是  1： 否
      isActive: 0 //选项卡
    };
  },
  // props: {
  //   showOwner: Boolean
  // },
  created() {},
  mounted() {
    // 监听，除了点击自己，点击其他地方将自身隐藏
    document.addEventListener("click", e => {
      const ownerMenu = document.getElementById("owner_menu"); //
      const ownerDataMenu = document.getElementById("ownerData_menu"); //我的数据
      const currentMenu = document.getElementById("current_menu"); //
      const footMenu = document.getElementById("foot_menu"); //
      // 金主
      if (ownerMenu && footMenu) {
        if (!ownerMenu.contains(e.target) && !footMenu.contains(e.target)) {
          console.log("区域外");
          this.showOwner = !this.showOwner;
          this.showCurrentMenu = true;
        }
      }
      // 我的数据
      if (ownerDataMenu && footMenu) {
        if (!ownerDataMenu.contains(e.target) && !footMenu.contains(e.target)) {
          console.log("区域外");
          this.showOwnerData = !this.showOwnerData;
          this.showCurrentMenu = true;
        }
      }
      // 查看更多;
      if (currentMenu) {
        if (currentMenu.contains(e.target)) {
          console.log("当前菜单", this.isActive);
          if (this.isActive == 0) {
            this.showOwner = true;
          } else {
            this.showOwnerData = true;
          }

          this.showCurrentMenu = false;
        }
      }
    });
  },
  methods: {
    // 底部菜单选择
    handleOwner(val) {
      this.isActive = val;
      // this.showMenu = !this.showMenu;
      if (val == 0) {
        // 金主
        this.showOwner = !this.showOwner;

        this.showCurrentMenu = false;
        this.showOwnerData = false;
        if (this.showOwner == false) {
          this.showCurrentMenu = !this.showCurrentMenu;
        }
      } else {
        // 我的数据
        this.showOwnerData = !this.showOwnerData;
        this.showCurrentMenu = false;
        this.showOwner = false;
        if (this.showOwnerData == false) {
          this.showCurrentMenu = !this.showCurrentMenu;
        }
      }
    },
    // 选择子菜单
    handleMenuItem(index, data) {
      var pathURL = data.pathUrl;
      this.isSelect = index;
      this.currentMenuName = data.pathName;
      this.currentMenuIcon = data.iconUrl;
      this.$router.push(pathURL).catch(err => {});
    },
    // 查看更多
    handleMore() {
      this.showCurrentMenu = false;
      if (this.isActive == 0) {
        // 金主
        this.showOwner = true;
      } else {
        // 我的数据
        this.showOwnerData = true;
      }
    }
  }
};
</script>
<style scoped>
.moblie_box {
  width: 99%;
}
.mobile_menu_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  color: #000;
  font-size: 10px;
  padding: 5px 25px;
}
.mobile_menu_item:hover,
.mobile_menu_item .moblie_link:hover {
  background: #e7f2ff;
  color: #157df8;
  font-size: 13px;
  padding: 5px 0px;
}

.moblie_link {
  text-decoration: none;
  color: #000;
}
.select_menu_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  background: #e7f2ff;
  color: #157df8;
  font-size: 13px;
  padding: 5px 25px;
}
.select_menu_item .moblie_link {
  color: #157df8;
}
.select_menu_item .line_item {
  display: block;
}
.select_menu_item .line_item {
  width: 5px;
  height: 35px;
  background: #157df7;
  margin-left: -25px;
  margin-bottom: -5px;
  margin-top: -5px;
  margin-right: 20px;
}
.current_menu {
}

.current_menu_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  background: #e7f2ff;
  color: #157df8;
  font-size: 13px;
  padding: 5px 25px;
}
.current_menu_item .line_item {
  width: 5px;
  height: 35px;
  background: #157df7;
  margin-left: -25px;
  margin-bottom: -5px;
  margin-top: -5px;
  margin-right: 20px;
}
.more_menu {
  color: #157df8;
  text-align: center;
  padding: 5px;
}
.foot_list_box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #fff;
}
.foot_item {
  width: 50%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  z-index: 99999;
}
.foot_item_active {
  width: 50%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  z-index: 99999;
  background: #94c4fc;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileOwner.vue